import "./GhostBlogLoader.scss";

export const GhostBlogLoader = () => {
  return (
      <>
          <div className="row row-cols-1 row-cols-lg-2  g-lg-2 col-md-10 offset-md-1 mt2">
              <div className="gcontainer-mobile">
                  <div className="ghostlogo ganimate"></div>
                  <div className="gduration_questions">
                      <div className="gduration ganimate"></div>
                      <div className="gquestions ganimate"></div>
                  </div>
              </div>
              <div className="gcontainer-mobile">
                  <div className="ghostlogo ganimate"></div>
                  <div className="gduration_questions">
                      <div className="gduration ganimate"></div>
                      <div className="gquestions ganimate"></div>
                  </div>
              </div>
          </div>

      </>
  );
};
